class ToastService {
  constructor() {
    this.listeners = [];
  }

  show(options) {
    const opts = {
      appearance: options.appearance || (options.color === 'danger' ? 'error' : (options.color === 'warning' ? 'warning' : 'success')),
      autoDismissTimeout: options.autoDismissTimeout || (options.appearance === 'error' || options.color === 'danger' ? 5000 : 3000),
      autoDismiss: true,
      ...options
    };
    this.listeners.forEach((l) => {
      try {
        l(opts);
      } catch (e) {
        console.error(e);
      }
    });
  }

  showError(message, duration = 5000) {
    this.show({ message, appearance: 'error', autoDismissTimeout: duration });
  }

  showSuccess(message, duration = 3000) {
    this.show({ message, appearance: 'success', autoDismissTimeout: duration });
  }

  showWarning(message, duration = 3000) {
    this.show({ message, appearance: 'warning', autoDismissTimeout: duration });
  }

  onToast(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }
}

export default new ToastService();
